import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Static imports used ONLY as fallback cache for the http-backend
import en from './locales/en.json';
import nl from './locales/nl.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import tr from './locales/tr.json';
import it from './locales/it.json';
import pl from './locales/pl.json';
import no from './locales/no.json';
import sv from './locales/sv.json';
import da from './locales/da.json';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const bundledLocales = { en, nl, de, fr, es, tr, it, pl, no, sv, da };

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'no', name: 'Norsk', flag: '🇳🇴' },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
  { code: 'da', name: 'Dansk', flag: '🇩🇰' }
];

// Custom backend that tries API first, falls back to bundled static imports
const BundledFallbackBackend = {
  type: 'backend',
  init() {},
  read(language, namespace, callback) {
    fetch(`${BACKEND_URL}/api/locales/${language}`, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => callback(null, data))
      .catch(() => {
        // API unavailable → use bundled static import as fallback
        const fallback = bundledLocales[language];
        if (fallback) {
          callback(null, fallback);
        } else {
          callback(new Error(`No translations for ${language}`), null);
        }
      });
  }
};

i18n
  .use(BundledFallbackBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'nl', 'de', 'fr', 'es', 'tr', 'it', 'pl', 'no', 'sv', 'da'],
    fallbackLng: 'en',
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
  });

export default i18n;
